import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import AuthLayout from 'layouts/AuthLayout';
import AuthService from 'services/authService';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    AuthService.login({ username, password }).then((response) => {
      if (response.status === 'Success') {
        toast.success(response.message);
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 1000);
      }
    });
  };

  return (
    <AuthLayout>
      <div className="max-w-md w-full space-y-8">
        <div
          className="
          h-fit
          bg-[#202020]
          px-8 pt-12 pb-10
          rounded-xl
          text-white
          "
        >
          <h1 className="text-4xl font-light">Login Page</h1>

          <div className="mt-8">
            <input
              className="
                w-full 
                bg-[#292929]
                outline-none
                rounded-lg px-3 p-4 mt-2
                "
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              className="
                w-full 
                bg-[#292929]
                outline-none
                rounded-lg px-3 p-4 mt-2
              "
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <div className="mt-5">
              <button type="submit" className="submit w-full rounded-lg p-4 bg-indigo-500 hover:bg-indigo-600 text-white" onClick={handleLogin}>
                Login
              </button>
            </div>

            <div className="flex justify-between gap-1 mt-3">
              <Link to="/forgot-password" className="text-gray-300">
                Forgotten password?
              </Link>
              <Link to="/register" className="text-indigo-300">
                Create an account
              </Link>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
